// @ts-nocheck

import Repository from './Repository'

export default {
  getClicksPerDay(access_token, store, { channel, date, users } = {}) {
    return Repository({ Authorization: access_token }).get(`/stores/${store}/clicksPerDay`, {
      params: {
        ...(channel && { channel: channel }),
        ...(date && { from: date.from, to: date.to }),
        ...(users && { users: users.join(',') }),
      },
    })
  },
  getUserStats(
    access_token,
    store,
    date,
    page = 1,
    sortBy,
    sortOrder,
    searchQuery,
    exportData = false,
  ) {
    const params = {
      ...(date.from && date.to && { from: date.from, to: date.to }),
      ...(sortBy && { orderBy: sortBy }),
      ...(sortOrder && { orderByOrder: sortOrder }),
      ...(searchQuery && { query: searchQuery }),
    }

    if (exportData) {
      return Repository({ Authorization: access_token }).get(`/stores/${store}/userStats`, {
        responseType: 'blob',
        params: {
          format: 'xlsx',
          ...params,
        },
      })
    } else {
      return Repository({ Authorization: access_token }).get(`/stores/${store}/userStats`, {
        params: {
          page: page,
          ...params,
        },
      })
    }
  },
  /** @deprecated use `useGetLinks` / `buildLinksExportUrl` from `@/api/links.api` instead */
  getLinkStats(
    access_token,
    store,
    date,
    page = 1,
    sortBy,
    sortOrder,
    searchQuery,
    users,
    trafficSourceCode,
    exportData = false,
  ) {
    const params = {
      ...(date.from && date.to && { from: date.from, to: date.to }),
      ...(sortBy && { orderBy: sortBy }),
      ...(sortOrder && { orderByOrder: sortOrder }),
      ...(users && { users: users.join(',') }),
      ...(searchQuery && { query: searchQuery }),
      ...(trafficSourceCode && { traffic_source_code: trafficSourceCode }),
    }
    if (exportData) {
      return Repository({ Authorization: access_token }).get(`/stores/${store}/linkStats`, {
        responseType: 'blob',
        params: {
          format: 'xlsx',
          ...params,
        },
      })
    } else {
      return Repository({ Authorization: access_token }).get(`/stores/${store}/linkStats`, {
        params: {
          page: page,
          ...params,
        },
      })
    }
  },
  getUserTags(access_token, store) {
    return Repository({ Authorization: access_token }).get(`/stores/${store}/user-tags`)
  },
  createUserTag(token, store, name) {
    return Repository({ Authorization: token }).post(`/stores/${store}/user-tags`, { name })
  },
  updateCostsOnUser(access_token, store, userId, costs) {
    return Repository({ Authorization: access_token }).post(
      `/stores/${store}/user/${userId}/offer`,
      costs,
    )
  },
  createOneTimePayment(access_token, store, userId, oneTimePayment) {
    return Repository({ Authorization: access_token }).post(
      `/stores/${store}/user/${userId}/oneTimePayment`,
      oneTimePayment,
    )
  },
  setUserTagsOnUser(access_token, store, userId, tags) {
    return Repository({ Authorization: access_token }).post(
      `/stores/${store}/user/${userId}/user-tags`,
      tags,
    )
  },
  getCampaigns(access_token, storeId, page, searchQuery, pagination = true) {
    return Repository({ Authorization: access_token }).get(`/stores/${storeId}/offers`, {
      params: {
        page: page || 1,
        ...(searchQuery && { name: searchQuery }),
        ...(pagination === false && { pagination: 0 }),
      },
    })
  },
  getStoreInvoices(access_token, storeId) {
    return Repository({ Authorization: access_token }).get(`/stores/${storeId}/invoices`)
  },
  async getTrafficSources(access_token) {
    const { data } = await Repository({ Authorization: access_token }).get('/traffic-sources')
    return data
  },
  createStore(body, access_token) {
    return Repository({ Authorization: access_token }).post('/v2/stores', body)
  },
  createAdvertiserRepresentative(body, access_token) {
    return Repository({ Authorization: access_token }).post('/v2/advertiser-representatives', body)
  },
  confirmSetup(setupIntentId, advertiserId, access_token) {
    return Repository({ Authorization: access_token }).post(
      `/v2/advertisers/${advertiserId}/payment-setup`,
      {
        payment_setup_id: setupIntentId,
      },
    )
  },
}
